export const defaultTheme = {
  id: "245e2382-3b59-41e6-ad51-b7c8ae149b13",
  name: "New theme name",
  bodyFont: {
    family: "Bitter",
    url: "https://fonts.googleapis.com/css?family=Bitter",
  },
  primaryColor: {
    "100": "#cccccc",
    "200": "#999999",
    "300": "#666666",
    "400": "#333333",
    "500": "#000000",
    "600": "#000000",
    "700": "#000000",
    "800": "#000000",
    "900": "#000000",
  },
  textOnPrimary: {
    "100": "#000000",
    "200": "#000000",
    "300": "#FFFFFF",
    "400": "#FFFFFF",
    "500": "#FFFFFF",
    "600": "#FFFFFF",
    "700": "#FFFFFF",
    "800": "#FFFFFF",
    "900": "#FFFFFF",
  },
  headingFont: {
    family: "Custom",
    url: "https://use.typekit.net/nbp5uea.css",
  },
  secondaryColor: {
    "100": "#ffffff",
    "200": "#ffffff",
    "300": "#ffffff",
    "400": "#ffffff",
    "500": "#FFFFFF",
    "600": "#cccccc",
    "700": "#999999",
    "800": "#666666",
    "900": "#323232",
  },
  textOnSecondary: {
    "100": "#000000",
    "200": "#000000",
    "300": "#000000",
    "400": "#000000",
    "500": "#000000",
    "600": "#000000",
    "700": "#000000",
    "800": "#FFFFFF",
    "900": "#FFFFFF",
  },
};
